import { Route, Routes } from 'react-router-dom';
import Login from '../tabs/login/Login';
import ForgotPassword from '../tabs/forgotPassword/ForgotPassword';
import ResetPassword from '../tabs/resetPassword/ResetPassword';
import Layout from '../components/layout/Layout';
import UserManagement from '../tabs/userManagement/UserManagement';
import RoleForm from '../tabs/userManagement/role/RoleForm/RoleForm';
import UserForm from '../tabs/userManagement/user/UserForm/UserForm';
import BuManagement from '../tabs/buManagement/BuManagement';
import BusinessUnitForm from '../tabs/buManagement/businessUnit/BusinessUnitForm/BusinessUnitForm';
import GroupBusinessUnitForm from '../tabs/buManagement/groupBu/GroupBuForm/GroupBuForm';
import ProjectForm from '../tabs/project/projectForm/ProjectForm';
import ListProject from '../tabs/project/listProject/ListProject';
import PhaseForm from '../tabs/project/phase/phaseForm/PhaseForm';
import PhaseDeadline from '../tabs/project/phase/phaseDeadline/PhaseDeadline';
import ListPhase from '../tabs/project/phase/listPhase/ListPhase';
import ProjectDetail from '../tabs/project/projectDetail/ProjectDetail';
import RemarkSettings from '../tabs/project/remarksSetting/RemarkSettings';
import RatingQuotaForm from '../tabs/project/ratingQuota/RatingQuotaForm';
import CalibrationForm from '../tabs/project/calibrationForm/CalibrationForm';
import SPMOSummary from '../tabs/spmo/SpmoSummary/SpmoSummay';
import SpmoDetail from '../tabs/spmo/SpmoDetail/SpmoDetail';
import DetailCurrentProject from '../tabs/activeProjectPage/detailCurrentProject/DetailCurrentProject';
import SummaryCurrentProject from '../tabs/activeProjectPage/summaryCurrentProject/SummaryCurrentProject';
import EmptyProject from '../tabs/activeProjectPage/summaryCurrentProject/EmptyProject';
import ProjectTotalSummary from '../tabs/activeProjectPage/projectTotalSummary/ProjectTotalSummary';
import RedirectPage from '../tabs/redirectPage/RedirectPage';
import RedirectPageSpmo from '../tabs/redirectPage/RedirectPageSpmo';
import Homepage from '../tabs/homepage/Homepage/Homepage';
import HomepageList from '../tabs/homepage/HomepageList/HomepageList';
import HomepageForm from '../tabs/homepage/HomepageForm/HomepageForm';
import Faq from '../tabs/faq/faq/Faq';
import FaqList from '../tabs/faq/faqList/FaqList';
import FaqForm from '../tabs/faq/faqForm/FaqForm';
import OAuthCallback from '../tabs/login/OAuthCallback';
import RedirectPageReset from '../tabs/redirectPage/RedirectPageReset';

function AppRouter() {
    return (
      <Routes>
          <Route path='/' index element={<Login/>}/>
          <Route path='/auth/callback' element={<OAuthCallback/>}/>
          <Route path='/' element={<Layout/>}>
            <Route path='home' element={<Homepage/>}/>
            <Route path='home/list' element={<HomepageList/>}/>
            <Route path='home/form' element={<HomepageForm/>}/>
            <Route path='home/form/:announcement_id' element={<HomepageForm/>}/>
            <Route path='projects'element={<SummaryCurrentProject/>}/>
            <Route path='projects/:project_id'element={<SummaryCurrentProject/>}/>
            <Route path='projects/:project_id/:bu_performance/:prev_calibrator/:prev_calibrator_name/:type'element={<DetailCurrentProject/>}/>
            <Route path='projects/:project_id/:bu_performance/:prev_calibrator/:prev_calibrator_name/:type/:watch'element={<DetailCurrentProject/>}/>
            <Route path='projects/:project_id/:bu_performance/:type'element={<DetailCurrentProject/>}/>
            <Route path='projects/:project_id/:bu_performance/:type/:watch'element={<DetailCurrentProject/>}/>
            <Route path='projects-summary-rating/:project_id/:bu_performance/:prev_calibrator/:rating/:watch'element={<DetailCurrentProject/>}/>
            <Route path='projects-summary-rating/:project_id/:bu_performance/:rating/:watch'element={<DetailCurrentProject/>}/>
            <Route path='projects-summary-rating/:project_id/:rating/:watch'element={<DetailCurrentProject/>}/>
            <Route path='projects-summary-all/:project_id'element={<ProjectTotalSummary/>}/>
            <Route path='project-list'element={<ListProject/>}/>
            <Route path='project-list/phase'element={<ListPhase/>}/>
            <Route path='project-list/phase/phase-form'element={<PhaseForm/>}/>
            <Route path='project-list/phase/phase-form/:phase_id'element={<PhaseForm/>}/>
            <Route path='project-list/project/:project_id/:tab_order'element={<ProjectDetail/>}/>
            <Route path='project-list/project/phase/:project_id'element={<PhaseDeadline/>}/>
            <Route path='project-list/rating-quota/:project_id'element={<RatingQuotaForm/>}/>
            <Route path='project-list/rating-quota/:project_id/:business_unit_id'element={<RatingQuotaForm/>}/>
            <Route path='project-list/calibration/:project_id'element={<CalibrationForm/>}/>
            <Route path='project-list/calibration/:project_id/:employee_id'element={<CalibrationForm/>}/>
            <Route path='project-list/project-form'element={<ProjectForm/>}/>
            <Route path='project-list/project-form/:project_id'element={<ProjectForm/>}/>
            <Route path='project-list/remarks-setting/:project_id'element={<RemarkSettings/>}/>
            <Route path='spmo-summary/:project_id'element={<SPMOSummary/>}/>
            <Route path='spmo-detail/:project_id/:calibrator_id/:calibrator_name/:business_unit_id/:order/:department_name'element={<SpmoDetail/>}/>
            <Route path='spmo-detail/:project_id/:calibrator_id/:calibrator_name/:business_unit_id/:order'element={<SpmoDetail/>}/>
            {/* <Route path='report'element={<ReportList/>}/> */}
            <Route path='user-management'element={<UserManagement/>}/>
            <Route path='user-management/user-form'element={<UserForm/>}/>
            <Route path='user-management/user-form/:user_id'element={<UserForm/>}/>
            <Route path='user-management/role-form'element={<RoleForm/>}/>
            <Route path='user-management/role-form/:role_id'element={<RoleForm/>}/>
            <Route path='user-management/:tab_order'element={<UserManagement/>}/>
            <Route path='bu-management'element={<BuManagement/>}/>
            <Route path='bu-management/bu-form'element={<BusinessUnitForm/>}/>
            <Route path='bu-management/bu-form/:bu_id'element={<BusinessUnitForm/>}/>
            <Route path='bu-management/gbu-form'element={<GroupBusinessUnitForm/>}/>
            <Route path='bu-management/gbu-form/:gbu_id'element={<GroupBusinessUnitForm/>}/>
            <Route path='bu-management/:tab_order'element={<BuManagement/>}/>
            <Route path='faq'element={<Faq/>}/>
            <Route path='faq/list'element={<FaqList/>}/>
            <Route path='faq/form'element={<FaqForm/>}/>
            <Route path='faq/form/:faq_id'element={<FaqForm/>}/>
          </Route>
          <Route path='/reset-password-calibration/:token'element={<RedirectPageReset/>}/>
          <Route path='/autologin/:token'element={<RedirectPage/>}/>
          <Route path='/autologin/:token/:project_id/:bu_performance/:prev_calibrator/:prev_calibrator_name'element={<RedirectPage/>}/>
          <Route path='/autologin-spmo/:token/:project_id/:calibrator_id/:business_unit_id/:phase'element={<RedirectPageSpmo/>}/>
          <Route path='/forgot-password' element={<ForgotPassword/>}/>
          <Route path='/reset-password/:email/:resetToken' element={<ResetPassword/>}/>
          <Route path='login' element={<Login/>}/>
          <Route path="*" element={<EmptyProject />} />
      </Routes>
    );
  }
  
  export default AppRouter;
  